<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <div >
      <iframe src='//traycheckout.desk360.com.br/tickets/new' frameborder="0" width="100%" scrolling="no" @load="load" v-show="iframe.loaded"></iframe>
    </div>
  </div>
</template>
<script>
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'

  export default {
    name: 'help',
    components: {
      Breadcrumb
    },
    data () {
      return {
        iframe: {
          loaded: false
        },
        index: '',
        crumbs: {
          'ico': 'ls-ico-question',
          'section': this.$t('help.main.help'),
          'paths': {
            0: {
              'title': this.$t('help.main.title'),
              'path': ''
            }
          }
        }
      }
    },
    methods: {
      load () {
        this.iframe.loaded = true
        this.$loader.hide()
      }
    }
  }
</script>

<style lang="scss" scoped>
  iframe {
    height: 860px;
  }
</style>



// WEBPACK FOOTER //
// Help.vue?4b2c384e